module.exports = __webpack_public_path__ + "img/Lobby_Banner2.4ca1da14.jpg";